/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Button_LabelInputs */

const en_chat_button_label = /** @type {(inputs: Chat_Button_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chat`)
};

const fr_chat_button_label = /** @type {(inputs: Chat_Button_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chat`)
};

const ms_sg2_chat_button_label = /** @type {(inputs: Chat_Button_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sembang`)
};

/**
* | output |
* | --- |
* | "Chat" |
*
* @param {Chat_Button_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const chat_button_label = /** @type {((inputs?: Chat_Button_LabelInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Button_LabelInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_chat_button_label(inputs)
	if (locale === "fr") return fr_chat_button_label(inputs)
	return ms_sg2_chat_button_label(inputs)
});